<template>
<!-- eslint-disable max-len -->
<div
  id="chart"
>
  <apexchart
    :options="chartOptions"
    :series="series"
  ></apexchart>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  props: {
    playthrough: Object,
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [
        // series get generated for cash and each team metric dynamically
      ],
      chartOptions: {
        chart: {
          height: 1000,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        // colors: ['#77B6EA', '#545454'], // TODO: colors?
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: 'Playthrough Metrics By Section',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: [], // dynamically populated with the section titles
          title: {
            text: 'Section'
          },
          labels: {
            offsetY: 4,
          },
        },
        yaxis: [
          // axes will get generated automatically for the dynamically generated series for each team metric (and cash)
        ],
        legend: {
          position: 'bottom',
          horizontalAlign: 'right',
          // floating: true,
          // offsetY: -25,
          // offsetX: -5
        },
      },
    };
  },
  computed: {
  },
  async created() {
    this.populateChart();
  },
  methods: {
    populateChart() {
      const { playthrough } = this;
      if (!playthrough) return;

      console.log(playthrough);

      // TODO: determine whether cash should show up based on game.showCashInReports
      const includeCash = playthrough.game.showCashInReports;

      // clear any existing values
      this.chartOptions.xaxis.categories.length = 0;
      this.series.length = 0;
      this.chartOptions.yaxis.length = 0;
      if (includeCash) {
        this.series.push({
          name: 'Cash',
          data: [],
        });
        this.chartOptions.yaxis.push({
          opposite: true,
          seriesName: 'Cash',
          title: {
            text: 'Cash'
          },
        });
      }

      // populate sections
      playthrough.challenges.forEach(({ _id: { title } }, cIndex) => {
        let titleWithTagsRemoved = title.replace(/<br>/g, ' ').replace(/<\/?\w[^>]*(>|$)/g, '');
        if (this.chartOptions.xaxis.categories.includes(titleWithTagsRemoved)) {
          titleWithTagsRemoved += ` (${cIndex + 1})`;
        }
        this.chartOptions.xaxis.categories.push(titleWithTagsRemoved);
      });

      // populate cash
      if (includeCash) {
        playthrough.challenges.forEach((c) => {
          if (c.endCash != null) {
            this.series[0].data.push(c.endCash);
          }
        });
        if (this.series[0].data.length < this.chartOptions.xaxis.categories.length) {
          this.series[0].data.push(playthrough.cash);
        }
      }

      // populate team metrics
      let sharedAxisSeriesName = '';
      playthrough.metrics.forEach(({ _id: { title, integer }, value }, mIndex) => {
        const data = [];
        playthrough.challenges.forEach(({ endMetrics }) => {
          if (endMetrics && endMetrics[mIndex]) {
            data.push((integer
              ? Math.round(endMetrics[mIndex].value)
              : (Math.round(endMetrics[mIndex].value * 1000) / 1000)));
          }
        });
        if (data.length < this.chartOptions.xaxis.categories.length) {
          data.push((integer
            ? Math.round(value)
            : (Math.round(value * 1000) / 1000)));
        }
        this.series.push({
          name: title,
          data,
        });
        if (mIndex === 0) {
          this.chartOptions.yaxis.push({
            seriesName: title,
            title: {
              text: 'Metric Value'
            },
          });
          sharedAxisSeriesName = title;
        } else {
          this.chartOptions.yaxis.push({
            seriesName: sharedAxisSeriesName,
            show: false,
          });
        }
      });

      this.chartOptions.chart.animations.animateGradually.delay = Math.min(150, Math.round(1000 / Math.max(1, this.series.length)));
    },
  },
  watch: {
    playthrough() {
      this.populateChart();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/PlaythroughMetricChart.vue